export enum SubmitFieldVisibility {
  Disabled = 'disabled',
  Hidden = 'hidden',
  Optional = 'optional',
  Required = 'required',
}
